import ClientLoyaltyInfo from './ClientLoyaltyInfo';

export default ClientLoyaltyInfo;
